// 风格配置文件
export const btnColor = '#6d2ef8' // 右边操作列按钮颜色

export const btnDisableColor = '#9D9CA4' // 右边操作列按钮禁用颜色

// export const btnDecryptColor = '#9D8AC9' // 表格监控字段、虚拟号字段解密

export const headerLineColor = '#CDD0DC' // 线框颜色

export const lineColor = '#E2E2E8' // 线框颜色

export const divideColor = '#6d2ef8' // 分割线颜色

export const headerTextColor = '#2f2e38' // 头部字体颜色

export const tableTextColor = '#1d1c23' // 表格字体颜色

export const headerColor = '#F0F1FB' // 头部背景色

export const activeRowColor = '#E9EBFD' // 活动行背景色

export const stripeColor = '#fafafa' // 斑马条纹

export const headerHeight = 32 // 表头高度

export const rowHeight = 32 // 行高

export const boxEmptyHeight = headerHeight + rowHeight // 无数据时高度

export const cellPaddingWidth = 6 // 间距

export const fontSize = 13 // 字体大小

export const maskSec = window.__ERPGLOABLECONFIG__.maskSec || '✽✽✽'



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/config.js